module.exports = __webpack_public_path__ + "static/media/barcode.822ce63d.png";